export interface InboxDisplayParty {
  company?: string | null;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
}

export interface InboxDisplayMessage {
  direction: string;
  metadata?: unknown;
}

function clean(value?: string | null) {
  return typeof value === 'string' ? value.trim() : '';
}

function metadataString(metadata: unknown, key: string) {
  if (!metadata || typeof metadata !== 'object') return '';
  const value = (metadata as Record<string, unknown>)[key];
  return typeof value === 'string' ? value.trim() : '';
}

export function compactInboxText(value?: string | null, fallback = '', maxLength = 160) {
  const cleaned = clean(value)
    .replace(/<div[^>]*(display\s*:\s*none|max\s*-\s*height\s*:\s*0|mso\s*-\s*hide)[\s\S]*?<\/div>/gi, ' ')
    .replace(/\[([^\]]{1,80})\]\([^)]+\)/g, '$1')
    .replace(/https?:\/\/\S+/gi, '[link]')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const text = cleaned || fallback;
  if (!text || text.length <= maxLength) return text;
  return `${text.slice(0, Math.max(0, maxLength - 3)).trimEnd()}...`;
}

export function formatInboxSender({
  party,
  message,
  fallback = 'Unknown',
}: {
  party?: InboxDisplayParty | null;
  message: InboxDisplayMessage;
  fallback?: string;
}) {
  const linkedSender =
    clean(party?.company) ||
    clean(party?.name) ||
    clean(party?.email) ||
    clean(party?.phone);
  if (linkedSender) return linkedSender;
  if (message.direction === 'outbound') return 'Team reply';

  const fromName = metadataString(message.metadata, 'fromName');
  const fromEmail = metadataString(message.metadata, 'fromEmail');
  if (fromName && fromEmail) return `${fromName} <${fromEmail}>`;
  if (fromName) return fromName;
  if (fromEmail) return fromEmail;

  const rawFrom = metadataString(message.metadata, 'from');
  return rawFrom || fallback;
}
